module.exports = __webpack_public_path__ + "static/media/sensor-smoke.1d4c1127.svg";